import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { ServicesGallery } from '@/components/sections/ServicesGallery';
import { PartnerLogos } from '@/components/sections/PartnerLogos';
import { CompanyInfo } from '@/components/sections/CompanyInfo';
import { Testimonials } from '@/components/sections/Testimonials';
import { CTASection } from '@/components/sections/CTASection';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        
        {/* Open Graph tags */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={siteData.title} />
        <meta property="og:description" content={siteData.description} />
        <meta property="og:url" content="https://chooseasi.com/" />
        <meta property="og:site_name" content="Choose ASI" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://chooseasi.com/" />
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        <Header />
        <Hero />
        <ServicesGallery />
        <PartnerLogos />
        <CompanyInfo />
        <Testimonials />
        <CTASection />
        <Footer />
      </div>
    </>
  );
}